import { useMemo } from 'react';
import { InputsConfig } from 'types/form/inputsConfig';

export const useInputsConfig = <T extends string>(
  config: InputsConfig<T>,
  disabledFields?: T[]
): InputsConfig<T> => {
  return useMemo(() => {
    if (!disabledFields) return config;

    return Object.keys(config).reduce((updatedConfig, key) => {
      const typedKey = key as T;
      const fieldConfig = config[typedKey];

      updatedConfig[typedKey] = {
        ...fieldConfig,
        disabled: disabledFields.includes(typedKey) ? true : (fieldConfig as any).disabled,
      } as typeof fieldConfig;

      return updatedConfig;
    }, { ...config } as InputsConfig<T>);
  }, [config, disabledFields]);
};
